const FORCE_IRAN_MODE = false;

const getCurrentHost = () => {
  return typeof window !== "undefined" ? window.location.hostname : "";
};

const currentHost = getCurrentHost();

export const IS_IR =
  currentHost.includes(".ir") ||
  currentHost === "localhost" ||
  currentHost === "127.0.0.1";

export const IS_IRANIAN_USER = IS_IR || FORCE_IRAN_MODE;

export const ir = (url) => {
  if (!url || typeof url !== "string") return url;

  // if (currentHost === "localhost" || currentHost === "127.0.0.1") {
  //   return url;
  // }

  return IS_IRANIAN_USER ? url.replace(/\.com/g, ".ir") : url;
};
